// Grid controls must respond even while the collection's module is still loading.
(() => {
  if (window.dmGridControlsLoaded) return;
  window.dmGridControlsLoaded = true;

  function applyChoice(input) {
    const controls = input.closest('[data-grid-density-controls]');
    const results = input.closest('results-list');
    const grid = results?.querySelector('.product-grid');
    if (!controls || !grid) return;

    const viewport = controls.dataset.gridDensityControls;
    const allowed = viewport === 'mobile' ? ['default', 'mobile-single'] : ['default', 'zoom-out'];
    if (!allowed.includes(input.value)) return;

    grid.setAttribute('product-grid-view', input.value);
    results.querySelectorAll(`[data-grid-density-controls="${viewport}"] input[type="radio"]`).forEach((option) => {
      option.checked = option.value === input.value;
    });
    try {
      sessionStorage.setItem(`product-grid-view-${viewport}`, input.value);
    } catch {
      // Private browsing may disable storage; the current layout still changes.
    }
    results.dispatchEvent(new CustomEvent('dm:grid-layout', { bubbles: true }));
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.matches('[data-grid-density-controls] input[type="radio"]')) {
      applyChoice(input);
    }
  });

  // Also repair an already-checked control after theme-editor DOM replacement.
  document.addEventListener('click', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.checked && input.matches('[data-grid-density-controls] input[type="radio"]')) {
      applyChoice(input);
    }
  });
})();
